import ProductsBrands from './ProductsBrands';

export default ProductsBrands;